import type { ITheme } from '@visactor/vchart';
import { colorScheme } from './color-scheme';
import { token } from '../common/token';

export const arcoDesignDark: ITheme = {
  name: 'arcoDesignDark',
  description: 'Arco Design - dark',
  type: 'dark',
  token,
  colorScheme
};
